// Единый вход ECMIT (ecmit_gate на ecmit.su/auth). Инструкция: ecmit_gate/docs/HOW_TO_MIGRATE.md.
const GATE_ORIGIN = 'https://ecmit.su'
const TRIED_KEY = 'ecmit_gate_tried'

/** `return` принимается «Входом» только для https и ecmit.su / *.ecmit.su, иначе подменяет адрес на главную. */
export function gateReturnAllowed(): boolean {
  return window.location.protocol === 'https:' && /(^|\.)ecmit\.su$/.test(window.location.hostname)
}

/** Тихая выдача cookie (если у человека живёт refresh-сессия), иначе «Вход» покажет форму входа. */
export function gateLoginUrl(returnTo: string = window.location.href, origin: string = GATE_ORIGIN): string {
  return `${origin}/auth/refresh?return=${encodeURIComponent(returnTo)}`
}

/** Выход гасит сессию везде; обычный переход, не fetch. */
export function gateLogoutUrl(returnTo: string, origin: string = GATE_ORIGIN): string {
  return `${origin}/auth/logout?return=${encodeURIComponent(returnTo)}`
}

export const GATE_HOME_URL = `${GATE_ORIGIN}/`

/** Один автоматический переход на «Вход» за вкладку: защита от цикла, если cookie не принимается. */
export function gateAutoRedirectUsed(): boolean {
  try { return !!sessionStorage.getItem(TRIED_KEY) } catch { return true }
}
export function markGateAutoRedirect(): void {
  try { sessionStorage.setItem(TRIED_KEY, '1') } catch { /* private mode */ }
}
export function clearGateAutoRedirect(): void {
  try { sessionStorage.removeItem(TRIED_KEY) } catch { /* private mode */ }
}

// --- Сессия закончилась посреди работы ------------------------------------------------------------------
// Сервер отвечает 401 с заголовком X-Login-URL, когда у человека больше нет ни ecmit_at, ни сессии CRM
// (7 дней без активности, 30 дней с начала сессии, блокировка в task, выход в другой вкладке).
// Страницу не перезагружаем и никуда не уводим: в ней может быть несохранённый черновик. Показываем плашку
// «Сессия закончилась» со ссылкой для входа в новой вкладке; после входа эта вкладка восстанавливается сама.
const RELOGIN_WINDOW_MS = 60_000
export const SESSION_LOST_EVENT = 'ecmit:session-lost'
let sessionActive = false

/** Человек вошёл в этой вкладке: только тогда потеря сессии считается «посреди работы». */
export function setSessionActive(active: boolean): void {
  sessionActive = active
}

export function handleSessionLost(loginUrl: string): void {
  if (!sessionActive) return
  window.dispatchEvent(new CustomEvent(SESSION_LOST_EVENT, { detail: { loginUrl } }))
}

// --- Ошибка загрузки чанка после обновления CRM --------------------------------------------------------
// После выкладки у файлов новые имена, а открытая вкладка просит старые. Один раз перезагружаем страницу,
// чтобы получить свежий index.html; защита от цикла: не чаще раза в минуту.
const CHUNK_RELOAD_KEY = 'ecmit_chunk_reload'

export function reloadOnceForChunkError(): boolean {
  let last = 0
  try { last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0) } catch { /* private mode */ }
  if (Date.now() - last <= RELOGIN_WINDOW_MS) return false
  try { sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now())) } catch { /* private mode */ }
  window.location.reload()
  return true
}

export function isChunkLoadError(reason: unknown): boolean {
  const message = String((reason as { message?: string } | null)?.message ?? reason ?? '')
  return /dynamically imported module|Loading chunk|Importing a module script failed|error loading dynamically imported/i.test(message)
}
